/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState, useImperativeHandle } from "react";
import { ContextMenu } from "./shared/gantt.js";

export default function ContextMenuComponent(props) {
  let table_container = useRef();

  const [state] = useState({});
  const [widget, setWidget] = useState(null);
  const once = useRef(false);

  useImperativeHandle(props.handler, () => function(ev){
    return widget.$$.ctx[widget.$$.props.handler](ev);
  });

  const { api } = props;
  useEffect(() => {
    const obj = new ContextMenu({
      target: table_container.current,
      props: {
        ...props
      },
    });

    state.handler = obj.$$.ctx[obj.$$.props.handler];
    if (props.init) props.init(state.handler);
    
    setWidget(() => obj);

    return () => {
      if (obj) try { obj.$destroy(); } catch (e) {}
      if (table_container.current) table_container.current.innerHTML = "";
    };
  }, [api]);

  useEffect(() => {
    if (!once.current) {
      once.current = true;
      return;
    }

    if (api && widget) {
      // exclude init from props
      const { init, ...updateProps } = props;
      widget.$$set(updateProps);
    }
  }, [api]);

  return (
    <div className={"wx-willow-theme"} ref={table_container}>
    </div>
  );
}
